import React from 'react';
import './App.css';
import Routess from './Router/Routes';

// Hello Friend

function App() {
  return (
    <div>
      <Routess/>
    </div>
  );
}

export default App;
